import React from 'react';
import parse from 'html-react-parser';

const Footer = ({texts}) => {
    if ( texts.length !== 0 ) {
        return (
            <div className="eaut-footer">
                <div className="inner">
                    <img className="eaut-footer-logo" src={texts.general_footer_logo_url} aria-hidden="true" alt="" />
                    {parse(texts.general_footer_wysiwyg)}
                </div>
            </div>
        );
    }
};

export default Footer;
